import React from 'react';

const ICONS = { ok: '✓', warn: '!', bad: '✕' };
const COLORS = { ok: 'text-success', warn: 'text-warning', bad: 'text-destructive' };

// The checks the server ran on an invoice (vendor on file and insured, totals, duplicates, ticket).
function InvoiceChecks({ checks }) {
  if (!checks || checks.length === 0) return null;
  return (
    <ul aria-label="Checks" className="space-y-1 text-sm">
      {checks.map((check, i) => (
        <li key={i} className="flex gap-2">
          <span aria-hidden="true" className={`${COLORS[check.level] || ''} font-semibold`}>{ICONS[check.level] || '•'}</span>
          <span className="text-foreground">{check.text}</span>
        </li>
      ))}
    </ul>
  );
}

export default InvoiceChecks;
